module.exports = __webpack_public_path__ + "img/Approve.2cd2f095.png";